import { IGroup } from "../groups/IGroup";
import { ILbl } from "./ILbl";

export class EmailExtractor {
    

    public static concat_unique(arr1: string[], arr2?:string[]): string[] {
        if (!arr1) arr1 = []
        if (!arr2) arr2 = []

        const sum:string[] = []
        for (let i=0;i<arr1.length;i++) { sum.push(arr1[i].trim())}
        for (let i=0;i<arr2.length;i++) { sum.push(arr2[i].trim())}

        const set:any = {}
        for (let i=0;i<sum.length;i++) {
          const key=sum[i]
          if (!set[key]) set[key]=1
        }

        const uniq:string[]=[]
        for (const k in set) {
          uniq.push(k)
        }
        
        uniq.sort();
        return uniq;
    }

    public static text_to_arr(txt:string):string[] {
        const emails=[]
        const hash:any={}
        if (!txt) txt=""
        txt=txt.trim()
        if (!txt.length) return []
        const arr=txt.split(",")
        return this.concat_unique(arr)
    }

    public static  arr_to_text(arr:string[]):string {
        if (!arr) return ""
        if (!arr.length) return ""
        arr = this.concat_unique(arr)
        return arr.join(", ")
    }



    get_email_arr_from_groups(groups: IGroup[]) {
        if (!groups) return []
        if (!groups.length) return []
        let arr:string[] =[]
        for (let i=0;i<groups.length;i++) {
          const contacts_text=groups[i].contacts
          const contact_arr = EmailExtractor.text_to_arr(contacts_text)
          arr = EmailExtractor.concat_unique(arr,contact_arr)
        }
        return arr;
      }
    
      
      async use_groups_from_clipboard(groups: IGroup[], lbl:ILbl) {
    
          if (!lbl) return;
          if (groups) lbl.groups = groups;
    
          let emails_from_groups:string[] = []
          if (lbl.groups && lbl.groups.length>0) {
            emails_from_groups  =  this.get_email_arr_from_groups(lbl.groups);
          }
          
          let emails_from_text:string[]= []
          if (lbl.email_do_akceptacji_text && lbl.email_do_akceptacji_text?.trim()) {
            emails_from_text = EmailExtractor.text_to_arr(lbl.email_do_akceptacji_text)
          }
    
          const email_do_akceptacji = EmailExtractor.concat_unique(emails_from_groups, emails_from_text)

          const email_do_akceptacji_text = email_do_akceptacji.join(", ")

          lbl.email_do_akceptacji = email_do_akceptacji
          lbl.email_do_akceptacji_text = email_do_akceptacji_text
    
        }
    
    
    
      async delete_group(groups:IGroup[],i:number, lbl:ILbl) {
        groups.splice(i, 1);
        await this.use_groups_from_clipboard(groups, lbl)
      }

}